import { FC, useMemo } from "react";
import {
    Box,
    Grid,
    Text,
    useBreakpointValue,
} from "@smile2impress/components/relaunch";

import { FooterLink, FooterLinkProps } from "./FooterLink";

export type FooterColumnProps = {
    title: string;
    links: FooterLinkProps[];
};

export const FooterColumn: FC<FooterColumnProps> = ({ title, links }) => {
    const isMobile = useBreakpointValue({ base: true, tablet: false });

    const memoizedLinks = useMemo(() => {
        return isMobile ? (
            <Grid templateColumns={{ base: "1fr 1fr" }}>
                {links.slice(0, 3).map((props, index) => (
                    <FooterLink {...props} key={`${props.id}-${index}`} />
                ))}
                {links.length > 3 &&
                    links
                        .slice(3)
                        .map((props, index) => (
                            <FooterLink
                                {...props}
                                key={`${props.id}-${index}`}
                            />
                        ))}
            </Grid>
        ) : (
            <Box>
                {links.map((props, index) => (
                    <FooterLink {...props} key={index} />
                ))}
            </Box>
        );
    }, [isMobile, links]);

    return (
        <Box>
            <Text textStyle="title3" mb={2}>
                {title}
            </Text>
            {memoizedLinks}
        </Box>
    );
};
